$(function () { objectFitImages() });